import store from "base/reducer/store";
import { FetchingActionType, PersistItemsActionType } from "features/Persist/actionTypes";
import { getTenantId } from "features/Tenant/tenantUtils";
import { InsertTenantIsActiveRequest, PatchTenantIdentifyRequest, TenantIsActiveResponse, TicketConfigClient } from "services/tenantManagementService";
import { tryCatchJsonByAction } from "utils/fetchUtils";

export const getSupportOrganizationsAction = () => {
	const tenantId = getTenantId()!;
	const client = new TicketConfigClient();
	return client.getSupportOrganizations(tenantId);
}

export const createSupportOrganizationAction = (model: InsertTenantIsActiveRequest) => {
	const tenantId = getTenantId()!;
	const client = new TicketConfigClient();
	return client.createSupportOrganization(tenantId, model);
}

export const deleteSupportOrganizationAction = (id: number) => {
	const tenantId = getTenantId()!;
	const client = new TicketConfigClient();
	return client.deleteSupportOrganization(tenantId, id);
}

export const updateSupportOrganizationAction = (model: PatchTenantIdentifyRequest) => {
	const tenantId = getTenantId()!;
	const client = new TicketConfigClient();
	return client.patchSupportOrganization(tenantId, model);
}

export const persistSupportOrganizationsAction = async () => {
	const state = store.getState();

	if (state.persistedSupportOrganization.fetching) {
		return;
	}

	store.dispatch(setSupportOrganizationsFetchingAction(true));

	const response = await tryCatchJsonByAction(getSupportOrganizationsAction);
	if (response.success) {
		store.dispatch(setSupportOrganizationsAction(response.items || []));
	} else {
		store.dispatch(setSupportOrganizationsFetchingAction(false));
	}
}

// redux
export const SUPPORT_ORGANIZATIONS_FETCHING = 'SUPPORT_ORGANIZATIONS_FETCHING';
export const SUPPORT_ORGANIZATIONS_SET = 'SUPPORT_ORGANIZATIONS_SET';

const setSupportOrganizationsFetchingAction = (fetching: boolean): FetchingActionType => {
	return {
		type: SUPPORT_ORGANIZATIONS_FETCHING,
		fetching
	}
}

const setSupportOrganizationsAction = (items: TenantIsActiveResponse[]): PersistItemsActionType<TenantIsActiveResponse> =>  {
	return {
		type: SUPPORT_ORGANIZATIONS_SET,
		items
	}
}